var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C20B1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_137_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7985 10.2098H10.2015V29.7898H29.7985V10.2098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_137_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1975 29.7901H17.1495V16.7341H21.0355V18.4751C21.0835 18.4501 21.1085 18.4451 21.1185 18.4311C21.5225 17.7763 22.096 17.2429 22.7783 16.8873C23.4606 16.5317 24.2264 16.3672 24.9945 16.4111C25.9379 16.3705 26.8748 16.585 27.7065 17.0321C28.1492 17.3033 28.5329 17.6606 28.8349 18.0828C29.1369 18.505 29.351 18.9836 29.4645 19.4901C29.687 20.3135 29.7973 21.1632 29.7925 22.0161C29.8105 24.5501 29.8015 27.0831 29.8025 29.6161C29.8025 29.6551 29.8025 29.6941 29.7945 29.7521H25.7335V29.4711C25.7335 27.4871 25.7465 25.5031 25.7265 23.5191C25.731 22.8436 25.6755 22.1689 25.5605 21.5031C25.5273 21.2494 25.4407 21.0055 25.3066 20.7876C25.1725 20.5696 24.9939 20.3824 24.7824 20.2383C24.5709 20.0943 24.3313 19.9965 24.0794 19.9515C23.8274 19.9065 23.5688 19.9152 23.3205 19.9771C22.7825 19.9968 22.2726 20.2224 21.8961 20.6072C21.5197 20.9921 21.3054 21.5068 21.2975 22.0451C21.2395 22.4952 21.2091 22.9484 21.2065 23.4021C21.1965 25.4341 21.2065 27.4651 21.2065 29.5021L21.1975 29.7901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5755 16.7303H10.5405V29.7863H14.5755V16.7303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 14.9378C11.9316 14.9368 11.3307 14.6867 10.8881 14.2426C10.4455 13.7985 10.1975 13.1968 10.1986 12.5698C10.1996 11.9429 10.4497 11.342 10.8938 10.8994C11.3379 10.4568 11.9396 10.2088 12.5666 10.2098C13.1935 10.2109 13.7944 10.461 14.237 10.9051C14.6796 11.3492 14.9276 11.9509 14.9266 12.5778C14.9255 13.2048 14.6754 13.8057 14.2313 14.2483C13.7872 14.6909 13.1855 14.9389 12.5586 14.9378Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.9364fad4fcc8cc27471fc63414ed3728.svg";
export { ForwardRef as ReactComponent };